import { HTMLAttributes, ReactElement } from "react";
import { Cancel, Tick } from "../../assets";
import moment from "moment-jalaali";

  interface Props extends HTMLAttributes<HTMLElement> {
    data?: any;
  }
  export function Timeline({ data }: Props): ReactElement {
  
    return (
      <div className="timeline">
        {data?.map((item:any, index:number) => (
          <div key={item?.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            <div className={`timeline-content ${index % 2 === 0 ? 'text-end' : 'text-start'}`} >
              {item.title && <h3 className={`${item.active ? "" : "timeline-content-title-disabled" } timeline-content-title`}>{item.title}</h3>}
              {item.description && <p className="timeline-content-desc">{item.description}</p>}
            {item.date && <div className="timeline-opposite">{item?.date && moment(`${item?.date}`, 'YYYY-M-D').format('jYYYY/jM/jD')}</div>}
            </div>
            <div className="timeline-separator">
              <div className={`${item.active ? "" : "timeline-dot-disabled"} timeline-dot`}>{item?.active ? <img src={Tick}/> : <Cancel color="#fff"/> }</div>
              {index !== data.length - 1 && <div className="timeline-connector" />}
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default Timeline;
  